// releases.js
// Notes:
// - Each release now has an ASCII `slug` for short links like /lehavot
// - Keep using /release/:slug in React Router + add a Vercel rewrite so /slug → /release/slug
// - For entries with a YouTube link, you can set either youtubeUrl or embedYoutubeId (both OK)

const releases = [
  {
    title: "יותר מדי מילים למועדון שפיצר פליפ",
    artist: "Sighdafekt",
    type: "Single",
    smartLink: "https://sigh.ffm.to/spitzerflip",
    cover: "https://i.imgur.com/LbhIXxE.jpeg",
    date: "2025-03-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "spitzerflip"
  },
    {
    title: "iLoveYou",
    artist: "Sighdafekt, Alon Mylo",
    type: "Single",
    smartLink: "https://open.spotify.com/track/6KnWM7TXRhE7WMNEtBLF1w?si=b0d9ba4aae224a12",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/4e/28/74/4e287490-7812-00fd-897c-6f94b91732b3/053000128694_cover.jpg/600x600bb.jpg",
    date: "2020-09-01",
    spotifyUrl: "https://open.spotify.com/track/6KnWM7TXRhE7WMNEtBLF1w?si=b0d9ba4aae224a12",
    appleUrl: "https://music.apple.com/il/album/iloveyou-single/1533892218?l=he",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "iloveyou"
  },
  {
    title: "ילדה רעה",
    artist: "שלומי לקאו, Guyku, Sighdafekt",
    type: "Single",
    smartLink: "https://ffm.to/yaldaraa",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/7b/f4/61/7bf461e9-1c2d-83d7-182f-5798acb9f28a/cover.jpg/600x600bb.jpg",
    date: "2025-04-01",
    spotifyUrl: "https://open.spotify.com/track/6XPDijPQvqQFaMBNwYqFq3?si=033cdca875a7438d",
    appleUrl: "https://music.apple.com/il/album/%D7%99%D7%9C%D7%93%D7%94-%D7%A8%D7%A2%D7%94/1807082091?i=1807082104&l=he",
    youtubeUrl: "https://youtu.be/TwT94MtKaSk?si=WZGvM8sMG8pK0V3K",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "yaldaraa"
  },
  {
    title: "העולם מסתובב",
    artist: "Ethel",
    type: "Single",
    smartLink: "https://ethel.link/haolammistovev",
    cover: "https://i.imgur.com/WFpm26n.jpeg",
    date: "2025-05-01",
    spotifyUrl: "https://open.spotify.com/track/7jcGXOFNr9SsoDBMkJ5Gac?si=bbcefbd688484edd",
    appleUrl: "https://music.apple.com/il/album/%D7%94%D7%A2%D7%95%D7%9C%D7%9D-%D7%9E%D7%A1%D7%AA%D7%95%D7%91%D7%91/1807301212?i=1807301221&l=he",
    youtubeUrl: "https://www.youtube.com/watch?v=s_UBd9RlRcY&list=RDs_UBd9RlRcY&start_radio=1",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "haolam-mistovev"
  },
  {
    title: "לילה לבן",
    artist: "Roy Nismo",
    type: "Single",
    smartLink: "https://ffm.to/laylalavan",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/37/e9/2c/37e92cda-23a2-4013-726f-0a805bfaf05d/artwork.jpg/600x600bb.jpg",
    date: "2024-10-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "laylalavan"
  },
  {
    title: "הלילה בא",
    artist: "יערה לוי",
    type: "Single",
    smartLink: "https://ffm.to/halaylaba",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/c7/25/25/c725256b-a692-bd3a-b127-cc176c1cb8ff/9999900360622.jpg/600x600bb.jpg",
    date: "2024-06-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "halayla-ba"
  },
  {
    title: "לחם עבודה",
    artist: "Roy Nismo",
    type: "Single",
    smartLink: "https://ffm.to/lehemavoda",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/08/89/f6/0889f612-d62f-38c9-9bbf-fdb5f393dca0/artwork.jpg/600x600bb.jpg",
    date: "2024-10-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "lehem-avoda"
  },
  {
    title: "חורף24",
    artist: "SHOWER",
    type: "Album",
    smartLink: "https://ffm.to/horef24",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/00/56/77/00567788-fcda-b197-9630-93b6baa1c945/artwork.jpg/600x600bb.jpg",
    date: "2024-11-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "horef24"
  },
  {
    title: "צלקות",
    artist: "SHOWER",
    type: "Album",
    smartLink: "https://ffm.to/tzalakot",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/2e/ba/d3/2ebad32e-f64a-c26c-0e5f-317036c9098e/artwork.jpg/600x600bb.jpg",
    date: "2023-05-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "tzalakot"
  },
  {
    title: "צלילי אהבה",
    artist: "Sighdafekt",
    type: "Album",
    smartLink: "https://sigh.ffm.to/lovesounds",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/ee/69/da/ee69da1b-efdb-785d-2146-e7bf9f33a249/cover.jpg/600x600bb.jpg",
    date: "2024-12-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "lovesounds"
  },
  {
    title: "לא סופר",
    artist: "סגולות, שאנן סטריט",
    type: "Single",
    smartLink: "https://ffm.to/losofer",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/61/7f/04/617f04fa-7d36-177d-2ed0-33aba22a67cb/199066440551.jpg/600x600bb.jpg",
    date: "2024-11-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "losofer"
  },
  {
    title: "שחקני קופסה",
    artist: "סגולות",
    type: "Album",
    smartLink: "https://ffm.to/sgulotalbum",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/73/e5/36/73e536b9-e7de-9aa4-f064-cec42c4465fb/199066744659.jpg/600x600bb.jpg",
    date: "2024-10-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "sgulotalbum"
  },
  {
    title: "ברבי",
    artist: "Sighdafekt ,Ethel",
    type: "Single",
    smartLink: "https://sigh.ffm.to/barbi",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/37/77/1a/37771a4f-a589-22c9-61ab-4ef7e1295f11/cover.jpg/600x600bb.jpg",
    date: "2024-06-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "barbi"
  },
  {
    title: "4 Track Live Session",
    artist: "Ethel",
    type: "Album",
    smartLink: "https://ffm.to/ethel4track",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/d6/60/a4/d660a40a-cce3-f7ef-190d-ffd71cc9c528/197187370658.jpg/600x600bb.jpg",
    date: "2023-09-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "ethel4track"
  },
  {
    title: "אהבת אמת",
    artist: "Sighdafekt",
    type: "Single",
    smartLink: "https://sigh.ffm.to/ahavatemet",
    cover: "https://cdn-images.dzcdn.net/images/cover/00c59a34e783760ddf3fb0792e3eeed4/500x500-000000-80-0-0.jpg",
    date: "2023-03-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "ahavatemet"
  },
  {
    title: "מחט רמיקס",
    artist: "Ethel",
    type: "Single",
    smartLink: "https://ffm.to/mahatremix",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/28/7c/95/287c9553-7944-b5e6-8e72-2e399e8f491f/197188583682.jpg/600x600bb.jpg",
    date: "2023-01-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "mahat-remix"
  },
  {
    title: "IDKY (Backyard Live Session)",
    artist: "Kizels",
    type: "Single",
    smartLink: "https://ffm.to/idkylive",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/74/21/88/742188ee-e8a4-731a-e139-ee9e595a795f/cover.jpg/600x600bb.jpg",
    date: "2022-05-10",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "idkylive"
  },
  {
    title: "לא ילדה טובה",
    artist: "Ethel",
    type: "Album",
    smartLink: "https://ethel.link/album",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/07/aa/89/07aa89d8-debd-598d-e9c2-267c5caaff54/196626949554.jpg/600x600bb.jpg",
    date: "2022-05-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "lo-yalda-tova"
  },
  {
    title: "חתולה רמיקס",
    artist: "Ethel",
    type: "Single",
    smartLink: "https://ffm.to/hatula-remix",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/e0/6a/22/e06a22a6-2129-c063-4bc2-9b8ae18268d2/196626679956.jpg/600x600bb.jpg",
    date: "2022-04-15",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "hatula-remix"
  },
  {
    title: "IDKY",
    artist: "Kizels",
    type: "Single",
    smartLink: "https://ffm.to/kizels-idky",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/0d/22/05/0d22057a-9c0b-df38-076c-adce07961e31/cover.jpg/600x600bb.jpg",
    date: "2022-04-10",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "idky"
  },
  {
    title: "חתולה",
    artist: "Ethel",
    type: "Single",
    smartLink: "https://ffm.to/hatula",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/60/fb/53/60fb5333-c877-c1b1-6ac3-255aa8f9cd03/196626514875.jpg/600x600bb.jpg",
    date: "2022-04-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "hatula"
  },
  {
    title: "ראשה",
    artist: "Ethel",
    type: "Single",
    smartLink: "https://ffm.to/ethel-russia",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/9e/2c/31/9e2c313f-f3fa-db7f-b1e9-fea7906c089e/196292137514.jpg/600x600bb.jpg",
    date: "2022-02-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "russia"
  },
  {
    title: "YYY EP",
    artist: "Sighdafekt",
    type: "Album",
    smartLink: "https://sigh.ffm.to/yyy",
    cover: "https://static1.squarespace.com/static/63d746c10e41a71f9fdee43c/63d74aaf29f1f824640c7ec5/63d74ac729f1f824640c95ea/1675053767606/Sighdafekt-artwork.jpeg",
    date: "2019-01-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "yyy"
  },
  {
    title: "Summers Over",
    artist: "Sighdafekt, יערה לוי, Iancu",
    type: "Single",
    smartLink: "https://sigh.ffm.to/summersover",
    cover: "https://cdn-images.dzcdn.net/images/cover/8b5701173c7838bf0677ab70c19c37b9/0x1900-000000-80-0-0.jpg",
    date: "2019-10-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "summersover"
  },
  {
    title: "שריטות",
    artist: "Stiki",
    type: "Single",
    smartLink: "https://ffm.to/stikisritot",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/58/30/a9/5830a989-725c-cabe-84c6-29ae0b8a7843/199538202090.jpg/600x600bb.jpg",
    date: "2024-10-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "stikisritot"
  },
  {
    title: "פשוט מוצא אותי",
    artist: "עדי יונתן כהן",
    type: "Album",
    smartLink: "https://ffm.to/pashutmozeoti",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/85/74/f7/8574f778-6aa9-9e25-5af2-3e9a7c068732/196862747440.jpg/600x600bb.jpg",
    date: "2022-05-01",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "pashutmozeoti"
  },
  {
    title: "ולפעמים אני מגזים",
    artist: "עדי יונתן כהן",
    type: "Album",
    smartLink: "https://ffm.to/velifamimanimagzim",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/21/ae/e9/21aee95f-ffc1-0f71-602c-5b02b6ada425/3616553895375.jpg/600x600bb.jpg",
    date: "2021-05-01",
    spotifyUrl: "PLACEHOLDER",
     appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "velifamim-ani-magzim"
  },
  {
    title: "ביטבלוק אחד - צפרירים 31",
    artist: "עופר ירקוני",
    type: "Album",
    smartLink: "https://album.link/s/6uk0PXkwpbIWIH2g0zOkER",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/1f/dd/fc/1fddfc17-7988-8ce8-220c-052b8930db85/198661940039.jpg/600x600bb.jpg",
    date: "2024-09-04",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "bitblock-tzafririm-31"
  },
  {
    title: "שלב הבתים",
    artist: "עופר ירקוני",
    type: "Album",
    smartLink: "https://ffm.to/shlavhabatim",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/da/17/85/da178586-fdc7-db90-335c-581f8fb903ef/197509158292.jpg/600x600bb.jpg",
    date: "2023-01-05",
    spotifyUrl: "PLACEHOLDER",
    appleUrl: "PLACEHOLDER",
    youtubeUrl: "PLACEHOLDER",
    embedYoutubeId: "PLACEHOLDER",
    embedSpotify: "PLACEHOLDER",
    slug: "shlavhabatim"
  },
{
  title: "להבות",
  artist: "SHOWER",
  type: "Single",
  smartLink: "https://ffm.to/lehavot",
  cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/3e/1c/1b/3e1c1bea-a55a-c8d4-b161-8640f66c945f/199538224092.jpg/600x600bb.jpg",
  date: "2025-07-30",
  spotifyUrl: "https://open.spotify.com/track/6gzk6QWr7GNoYEf6z3LCCr?si=56e383c2f3c44831",
  appleUrl: "https://music.apple.com/il/album/%D7%9C%D7%94%D7%91%D7%95%D7%AA-single/1825659035?l=he",
  youtubeUrl: "https://www.youtube.com/watch?v=te-mOJCANt4",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "lehavot",
  socials: {
    instagram: "https://www.instagram.com/showerbitch",
    tiktok: "https://www.tiktok.com/@showerbih",
    website: "https://www.yensound.com/artist/shower",
    youtube: "https://www.youtube.com/channel/UClxqI3whK3DF6F4W4Q9hO7A"
  }
},
{
  title: "?מה הקטע",
  artist: "רומי רוט",
  type: "Single",
  smartLink: "https://ffm.to/mahaketa",
  cover: "https://i.postimg.cc/RZSP64zh/temp-Image-URNKLI.avif",
  date: "2025-09-01",
  spotifyUrl: "https://open.spotify.com/album/5LH93x61xY006eZQbItr4A",
  appleUrl: "https://geo.music.apple.com/au/album/%D7%9E%D7%94-%D7%94%D7%A7%D7%98%D7%A2-single/1835259398?app=music&ls=1",
  youtubeUrl: "https://www.youtube.com/watch?v=wP9pbuR13Ew",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "MaHaketa",
  socials: {
    instagram: "https://www.instagram.com/romi_roth/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@romi_roth"
  }
},
{
  title: "PURPLE",
  artist: "Kizels",
  type: "Album",
  smartLink: "https://ffm.to/kizels",
  cover: "https://i.postimg.cc/SR8L5PcL/temp-Imagexc0a6t.avif",
  date: "2025-09-04",
  spotifyUrl: "https://open.spotify.com/album/24CmY9HcCL7TLY1EyNHV0t?si=yLY-uv2KQqeBZnTs0C_LFg",
  appleUrl: "https://music.apple.com/il/album/purple-ep/1831627106?l=he",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "purple",
  socials: {
    instagram: "https://www.instagram.com/kizels/",
    tiktok: "https://www.tiktok.com/@kizels?_t=ZS-8vugUgcCKAC&_r=1",
    website: "https://www.yensound.com/artist/kizels",
    youtube: "https://www.youtube.com/channel/UC7ma1m68GZoy7STYPAwgmYQ"
  }
},
{
  title: "בראשית",
  artist: "יהלי",
  type: "Single",
  smartLink: "https://ffm.to/bereshit",
  cover: "https://i.postimg.cc/dV9zGKT2/temp-Imageu-Pezzj.avif",
  date: "2025-09-14",
  spotifyUrl: "https://open.spotify.com/album/4Q6mWlHshr8zSSurzNUyHY?si=2tnnvCBDRK-oGjKLBK3zMQ",
  appleUrl: "https://music.apple.com/il/album/%D7%91%D7%A8%D7%90%D7%A9%D7%99%D7%AA-single/1838307735?l=he",
  youtubeUrl: "https://www.youtube.com/watch?v=hRo2y0U-N_k",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "bereshit",
  socials: {
    instagram: "https://www.instagram.com/yalzzii/",
    tiktok: "https://www.tiktok.com/@yalzzii",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@Yalzzii"
  }
},
{
  title: "עכביש",
  artist: "SHOWER",
  type: "Single",
  smartLink: "https://ffm.to/akavish",
  cover: "https://i.postimg.cc/448vq9mf/temp-Imagez-Mda-N5.avif",
  date: "2025-09-25",
  releaseAt: "2025-09-25",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "akavish",
  background: { url: "https://i.imgur.com/PTi17HP.gif", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/showerbitch",
    tiktok: "https://www.tiktok.com/@showerbih",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UClxqI3whK3DF6F4W4Q9hO7A"
  }
},

{
  title: "מהופנט",
  artist: "Guyku, דור3",
  type: "Single",
  smartLink: "https://ffm.to/mehupnat",
  cover: "https://i.postimg.cc/VkSvxXy8/Guyku-Music.jpg",
  date: "2024-10-02",
  releaseAt: "2025-09-29",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "mehupnat",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/guykumusic",
    tiktok: "https://www.tiktok.com/@guykumusic",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UC4br3D4m3YoLySDKdU1mWGQ"
  }
},
{
  title: "RIGSHI VOL #1",
  artist: "RIGSHI",
  type: "Album",
  smartLink: "https://ffm.to/rigshi",
  cover: "https://i.postimg.cc/25QZtnv5/temp-Imageskyard.avif",
  date: "2025-09-28",
  releaseAt: "2025-09-28",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "rigshivol1",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/rig.shi_fam/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@RIGSHI"
  }
},
{
  title: "אמסטרדם",
  artist: "Roy Nismo",
  type: "Single",
  smartLink: "https://ffm.to/royamsterdam",
  cover: "https://i.postimg.cc/0jdtZG9j/'mstrdm-q'br-'rt-rwy-'whnh.jpg",
  date: "2025-11-27",
  releaseAt: "2025-11-27",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "royamsterdam",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/roynismo_ ",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UC67NJc8bfMYQNFnM7UTYBgA"
  }
},
{
  title: "פילטרים 5.3 (REMIX)",
  artist: "SHOWER, אלוני, מוזס",
  type: "Single",
  smartLink: "https://ffm.to/FilterimRemix",
  cover: "https://i.postimg.cc/4x7jYQjb/5-3-q'brswpy-'dm-glnz.png",
  date: "2025-12-25",
  releaseAt: "2025-12-25",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "https://www.youtube.com/watch?v=hp7cVCsok1w",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "filterim53remix",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/showerbitch",
    tiktok: "https://www.tiktok.com/@showerbih",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UClxqI3whK3DF6F4W4Q9hO7A"
  }
},

{
  title: "ראשקט",
  artist: "אלוני",
  type: "Single",
  smartLink: "https://ffm.to/Roshaket",
  cover: "https://i.postimg.cc/pLsYMwsw/IMG-2797-'ytmr-'lwny.jpg",
  date: "2026-01-04",
  releaseAt: "2026-01-04",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "roshaketsingle",
 background: { url: "https://i.postimg.cc/tgTg8fcc/ROSHSHAKET2-ezgif-com-crop-(1).gif", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/_al0ni/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@aloni-n9d/videos"
  }
},


{
  title: "ראשקט",
  artist: "אלוני",
  type: "Album",
  smartLink: "https://ffm.to/AloniAlbum",
  cover: "https://i.postimg.cc/BQGjYmBT/IMG-2805-'ytmr-'lwny.jpg",
  date: "2026-01-18",
  releaseAt: "2026-01-18",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "roshaketalbum",
  background: { url: "https://i.postimg.cc/tgTg8fcc/ROSHSHAKET2-ezgif-com-crop-(1).gif", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/_al0ni/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@aloni-n9d/videos"
  }
},

{
  title: "חצי יבש",
  artist: "E$H, Sighdafekt",
  type: "Single",
  smartLink: "https://ffm.to/halfdry",
  cover: "https://i.postimg.cc/tg0DmF3C/hzy-ybs-bkl-hmqwmwt-lynq-bbyw.jpg",
  date: "2026-01-29",
  releaseAt: "2026-01-29",
  spotifyUrl: "https://open.spotify.com/track/4rmp9kwBF0AhxUX8spPLlY?si=3c81d35a091e41d3",
  appleUrl: "https://music.apple.com/il/album/%D7%97%D7%A6%D7%99-%D7%99%D7%91%D7%A9-feat-sighdafekt/1869877597?i=1869877598&l=he",
  youtubeUrl: "https://www.youtube.com/watch?v=q_-iMQxxc9A",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "halfdry",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/eshpapi_/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UCKko4zNZRyDXN2shcnLY3Pg"
  }
},

{
  title: "אלבי",
  artist: "E$H",
  type: "Single",
  smartLink: "https://ffm.to/eshalbi",
  cover: "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/b7/d4/65/b7d4651d-6873-5add-dc99-191f79aea33d/820200337733.jpg/600x600bb.jpg",
  date: "2026-02-12",
  releaseAt: "2026-02-12",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "https://youtu.be/rRaE1PIF0Go?si=A5sP6Meait0zsaXx",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "albi",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/eshpapi_/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UCKko4zNZRyDXN2shcnLY3Pg"
  }
},

{
  title: "מה חשבת?",
  artist: "COCO",
  type: "Single",
  smartLink: "https://ffm.to/MaHashavta",
  cover: "https://i.postimg.cc/hGj769wk/Whats-App-Image-2026-02-11-at-15-06-21.jpg",
  date: "2026-02-14",
  releaseAt: "2026-02-14",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "https://www.youtube.com/watch?v=ziClR3W85dk",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "MaHashavta",
  background: { url: "PLACEHOLDER", darken: 0.0 }   ,
  socials: {
    instagram: "https://www.instagram.com/_itscoco__/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/@ItS-Coco-x"
  }
},
{
  title: "תסתכלי עליי",
  artist: "E$H",
  type: "Single",
  smartLink: "https://ffm.to/tistaklialai",
  cover: "https://i.postimg.cc/7hNzXwwD/E4AFAC48_E41A_4179_A97F_8666DF568BA8_(2)_Maor_Bezalel.jpg",
  date: "2026-02-19",
  releaseAt: "2026-02-19",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "https://www.youtube.com/watch?v=afc9yRqqDTY",
  embedYoutubeId: "afc9yRqqDTY",
  embedSpotify: "PLACEHOLDER",
  slug: "tistaklialai",
  background: { url: "PLACEHOLDER", darken: 0.0 },
  socials: {
    instagram: "https://www.instagram.com/eshpapi_/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UCKko4zNZRyDXN2shcnLY3Pg"
  }
},
{
  title: "אור אדום",
  artist: "Roy Nismo",
  type: "Single",
  smartLink: "https://ffm.to/oradom",
  cover: "https://i.postimg.cc/vTy9WcR3/אור_אדום_קאברארט_רוי_אוחנה_(רוי_ניסמו).jpg",
  date: "2026-02-25",
  releaseAt: "2026-02-25",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "oradom",
  background: { url: "PLACEHOLDER", darken: 0.0 },
  socials: {
    instagram: "https://www.instagram.com/roynismo_",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UC67NJc8bfMYQNFnM7UTYBgA"
  }
},
{
  title: "בחיים האלה",
  artist: "SHOWER",
  type: "Single",
  smartLink: "https://ffm.to/bahaimhaele",
  cover: "https://i.postimg.cc/bY01qHbr/צילום_מסך_2026_02_15_ב_19_33_01_jpg_אדם_גלנץ.jpg",
  date: "2026-03-01",
  releaseAt: "2026-03-01",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "bahaimhaele",
  background: { url: "PLACEHOLDER", darken: 0.0 },
  socials: {
    instagram: "https://www.instagram.com/showerbitch",
    tiktok: "https://www.tiktok.com/@showerbih",
    website: "PLACEHOLDER",
    youtube: "https://www.youtube.com/channel/UClxqI3whK3DF6F4W4Q9hO7A"
  }
},
{
  title: "ביטבלוק #2",
  artist: "עופר ירקוני",
  type: "Album",
  smartLink: "https://ffm.to/beatblock2",
  cover: "https://i.postimg.cc/L4kjmBfJ/BEATBLOCK2_COVER_Ofer_Yarkoni.jpg",
  date: "2026-02-26",
  releaseAt: "2026-02-26",
  spotifyUrl: "PLACEHOLDER",
  appleUrl: "PLACEHOLDER",
  youtubeUrl: "PLACEHOLDER",
  embedYoutubeId: "PLACEHOLDER",
  embedSpotify: "PLACEHOLDER",
  slug: "beatblock2",
  background: { url: "PLACEHOLDER", darken: 0.0 },
  socials: {
    instagram: "https://www.instagram.com/ofer_yarkoni/",
    tiktok: "PLACEHOLDER",
    website: "PLACEHOLDER",
    youtube: "PLACEHOLDER"
  }
},


  {
    title: "כיוונים שונים",
    artist: "Ethel, Sighdafekt, Gangsburg",
    type: "Single",
    smartLink: "https://ffm.to/kivunimshonim",
    cover: "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/e6/4b/40/e64b407e-59f7-04ee-09c4-b3514efd0a8f/199538224252.jpg/600x600bb.jpg",
    date: "2025-07-31",
    spotifyUrl: "https://open.spotify.com/track/0ftpq7ZZvlSP5lDHehLpGs?si=bdf7ef074e5043ed",
    appleUrl: "https://music.apple.com/il/album/%D7%9B%D7%99%D7%95%D7%95%D7%A0%D7%99%D7%9D-%D7%A9%D7%95%D7%A0%D7%99%D7%9D-single/1825658200?l=he",
    youtubeUrl: "https://www.youtube.com/watch?v=dxHyjFmKwUg",
    embedYoutubeId: "dxHyjFmKwUg",
    embedSpotify: "https://open.spotify.com/embed/track/0ftpq7ZZvlSP5lDHehLpGs?utm_source=generator",
    slug: "kivunim-shonim"
  }
];

export default releases;
